export const withCopyNumber = (fileName: string, copyNumber: number) => {
  const extensionStart = fileName.lastIndexOf('.');

  if (extensionStart <= 0) {
    return `${fileName} (${copyNumber})`;
  }

  return `${fileName.slice(0, extensionStart)} (${copyNumber})${fileName.slice(extensionStart)}`;
};
